import PropTypes from 'prop-types';
import { useAnalytics } from 'use-analytics';
import { useSelector } from 'react-redux';

const ReferLabelRoomDescription = ({ room }) => {
  const { travelAgency, hotelRateCodes } = useSelector((store) => store.user);
  const { track } = useAnalytics();

  const code = room && (room.ratePlanClientId || room.ratePlanCode);
  const matchedRateCode =
    code && hotelRateCodes && hotelRateCodes.length
      ? hotelRateCodes.find((c) => c.rateCode === code)
      : null;

  if (matchedRateCode && matchedRateCode.description) {
    return <div dangerouslySetInnerHTML={{ __html: matchedRateCode.description }} />;
  }

  const virtuosoRateLabelInRoomDescription =
    travelAgency &&
    travelAgency.settings &&
    travelAgency.settings.virtuosoRateLabelInRoomDescription;

  if (virtuosoRateLabelInRoomDescription && (code === 'API' || code === 'VMC')) {
    const handleLinkToVirtuosoWebsite = () => {
      track('redirectToVirtuosoWebsite');
    };

    return (
      <div
        role="button"
        aria-label="Click"
        onClick={handleLinkToVirtuosoWebsite}
        onKeyDown={handleLinkToVirtuosoWebsite}
        dangerouslySetInnerHTML={{ __html: virtuosoRateLabelInRoomDescription }}
        tabIndex={0}
      />
    );
  }

  return null;
};

ReferLabelRoomDescription.propTypes = {
  room: PropTypes.shape().isRequired,
};

export default ReferLabelRoomDescription;
